module.exports = __webpack_public_path__ + "view/2019/img/yellow_background_rtl.png";